import Vue from 'vue';
import Router from 'vue-router';
import { Analytics } from './analytics.js';
// Main "pages" of the application
import HomePage from './views/HomePage.vue';
import SettingsPage from './views/SettingsPage.vue';
import WaitingForTvPage from './views/WaitingForTvPage';
import ChooseDevicePage from './views/ChooseDevicePage.vue';
import RemotePage from './views/RemotePage.vue';
import SeaButtonsPage from './views/SeaButtonsPage.vue';
import EditButtonOrderPage from './views/EditButtonOrderPage.vue';
import TVConfigPage from './views/TVConfigPage.vue';
import ErrorPage from './views/ErrorPage.vue';
import LoginAgainPage from './views/LoginAgainPage.vue';
import FourOhFourPage from './views/FourOhFourPage.vue';
import LearnMorePage from './views/LearnMorePage.vue';
import LoginCompletePage from './views/LoginCompletePage.vue';
import LogoutCompletePage from './views/LogoutCompletePage.vue';
import CompanionHomePage from './views/CompanionHomePage';
import CompanionSuccessPage from './views/CompanionSuccessPage';
import ChoosePopularButtonsPage from './views/ChoosePopularButtonsPage';
import EditCustomButtonPage from './views/EditCustomButtonPage';
import AddNewButtonPage from './views/AddNewButtonPage';
import NewVersionPage from './views/NewVersionPage.vue';
import ASLInterfacePage from './views/ASLInterfacePage';
import ASLConsentPage from './views/ASLConsentPage';
import ASLGettingStartedPage from './views/ASLGettingStartedPage.vue';

Vue.use(Router);

// NOTES:
//   - The following are *server-side* routes:
//       - /login
//       - NOT!: login-complete
//       - /logout
//       - NOT!: logout-complete
//       - /api/v*/*
//       - /api/healthcheck
//       - /api/health/cf
//
//   - To generate a separate chunk (foo.[hash].js) for a route, which is lazy-loaded when the route is visited,
//     instead of using
//         component: Foo"
//     use
//         component() { return import(/* webpackChunkName: "foo" */ './views/Foo.vue');

// NOTE: Make sure this list of paths matches the paths in /src/server/index.js
const routes = [
	{ path: '/',                    name: 'homePage',                 component: HomePage,                 meta: { title: 'Home'                } },
	{ path: '/settings',            name: 'settingsPage',             component: SettingsPage,             meta: { title: 'Settings'            } },
	{ path: '/companion',           name: 'companionHomePage',        component: CompanionHomePage,        meta: { title: 'Companion'           } },
	{ path: '/companion-success',   name: 'companionSuccessPage',     component: CompanionSuccessPage,     meta: { title: 'Companion Success'   } },
	{ path: '/add-popular-buttons', name: 'choosePopularButtonsPage', component: ChoosePopularButtonsPage, meta: { title: 'Add Popular Buttons' } },
	{ path: '/login-complete',      name: 'loginCompletePage',        component: LoginCompletePage,        meta: { title: 'Login Complete'      } },
	{ path: '/logout-complete',     name: 'logoutCompletePage',       component: LogoutCompletePage,       meta: { title: 'Logout Complete'     } },
	{ path: '/waiting-for-tv',      name: 'waitingForTvPage',         component: WaitingForTvPage,         meta: { title: 'Waiting for TV'      } },
	{ path: '/choose-device',       name: 'chooseDevicePage',         component: ChooseDevicePage,         meta: { title: 'Choose Device'       } },
	{ path: '/remote',              name: 'remotePage',               component: RemotePage,               meta: { title: 'Remote'              } },
	{ path: '/my-remote',           name: 'seaButtonsPage',           component: SeaButtonsPage,           meta: { title: 'My Remote'           } },
	{ path: '/my-remote-config',    name: 'editButtonOrderPage',      component: EditButtonOrderPage,      meta: { title: 'Edit Button Order'   } },
	{ path: '/tv-config',           name: 'tvConfigPage',             component: TVConfigPage,             meta: { title: 'TV Config'           } },
	{ path: '/edit-custom-button',  name: 'editCustomButtonPage',     component: EditCustomButtonPage,     meta: { title: 'Edit Custom Button'  } },
	{ path: '/add-new-button',      name: 'addNewButtonPage',         component: AddNewButtonPage,         meta: { title: 'Add New Button'      } },
	{ path: '/learn-more',          name: 'learnMorePage',            component: LearnMorePage,            meta: { title: 'Learn More'          } },
	{ path: '/error',               name: 'errorPage',                component: ErrorPage,                meta: { title: 'Error'               } },
	{ path: '/login-again',         name: 'loginAgainPage',           component: LoginAgainPage,           meta: { title: 'Login Again'         } },
	{ path: '/new-version',         name: 'newVersionPage',           component: NewVersionPage,           meta: { title: 'New Version'         } },
	{ path: '/asl-interface',       name: 'aslInterfacePage',         component: ASLInterfacePage,         meta: { title: 'ASL Interface'       } },
	{ path: '/asl-consent',         name: 'aslConsentPage',           component: ASLConsentPage,           meta: { title: 'ASL Consent'         } },
	{ path: '/asl-getting-started', name: 'aslGettingStartedPage',    component: ASLGettingStartedPage,    meta: { title: 'ASL Getting Started' } },

	{ path: '*',                    name: 'fourOhFourPage',           component: FourOhFourPage,           meta: { title: 'Page Not Found'      } }
];

const arRouter = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: routes,
});

arRouter.afterEach(( to, from ) => {
	// Could use meta.title values in the route table to set document.title
	//if (to.meta && to.meta.title) {
	//	document.title = to.meta.title;
	//}

	Analytics.page({
		pageName: ( to.meta ? to.meta.title : 'Unknown Page' ),
		path: to.fullPath,
		properties: {
			routeName: to.name || ''
		},
		callback: null
	});
});

window.arRouter = arRouter; // For use within AccessibleRemote.js
export default arRouter;
